// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/notice-bar/style/index.less
// module id = 113
// module chunks = 0